<template>
    <ContentLoader 
        :speed="3"
        width="560"
        height="600"
        view-box="0 0 560 600"
        background-color="#f3f3f3"
        foreground-color="#ecebeb"
    >
        <rect x="6" y="15" rx="0" ry="0" width="519" height="27" /> 
        <rect x="0" y="57" rx="0" ry="0" width="584" height="2" /> 
        <rect x="15" y="74" rx="0" ry="0" width="24" height="27" /> 
        <rect x="42" y="74" rx="0" ry="0" width="484" height="27" /> 
        <rect x="0" y="116" rx="0" ry="0" width="584" height="2" /> 
        <rect x="15" y="133" rx="0" ry="0" width="24" height="27" /> 
        <rect x="42" y="133" rx="0" ry="0" width="484" height="27" /> 
        <rect x="0" y="175" rx="0" ry="0" width="584" height="2" /> 
        <rect x="42" y="192" rx="0" ry="0" width="484" height="27" /> 
        <rect x="15" y="192" rx="0" ry="0" width="24" height="27" /> 
        <rect x="0" y="352" rx="0" ry="0" width="584" height="2" /> 
        <rect x="15" y="251" rx="0" ry="0" width="24" height="27" /> 
        <rect x="42" y="251" rx="0" ry="0" width="484" height="27" /> 
        <rect x="0" y="234" rx="0" ry="0" width="584" height="2" /> 
        <rect x="0" y="293" rx="0" ry="0" width="584" height="2" /> 
        <rect x="15" y="310" rx="0" ry="0" width="24" height="27" /> 
        <rect x="42" y="310" rx="0" ry="0" width="484" height="27" /> 
        <rect x="42" y="369" rx="0" ry="0" width="484" height="27" /> 
        <rect x="15" y="369" rx="0" ry="0" width="24" height="27" /> 
        <rect x="0" y="411" rx="0" ry="0" width="584" height="2" /> 
        <rect x="42" y="428" rx="0" ry="0" width="484" height="27" /> 
        <rect x="15" y="428" rx="0" ry="0" width="24" height="27" /> 
        <rect x="0" y="470" rx="0" ry="0" width="584" height="2" />
    </ContentLoader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "TableWithFolderSideBar",
    components: { ContentLoader }
};
</script>